import css from 'styled-jsx/css';
import React from 'react';
// TODO: Migrate module so that you don’t import from the corp project in a global module
/* eslint-disable restrict-imports/restrict-imports */
import SectionTitle from 'corp/components/UI/SectionTitle';
import { Section } from 'react-scale/containers/corp/backfills/batch/components/Section';
import DetailedInfoAction from 'react-scale/corp/components/RoadRunner/DetailedInfo';
import UpdateDeliveryAction from 'react-scale/corp/components/RoadRunner/UpdateDelivery';
import GenerateDeliveryAction from 'react-scale/corp/components/RoadRunner/GenerateDelivery';
import RefreshAuditAction from 'react-scale/corp/components/RoadRunner/RefreshAudit';
import { IUserJson } from '@scale/shared/types/user';

const style = css`
  .root .two-columns {
    display: flex;
  }
  .root .two-columns section {
    flex-basis: 50%;
  }
  .root .two-columns section.disabled {
    color: rgba(0, 0, 0, 0.3);
  }
  .root .three-columns {
    display: flex;
  }
  .root .three-columns section {
    flex-basis: 33%;
  }
  .root .three-columns section.disabled {
    color: rgba(0, 0, 0, 0.3);
  }
  .root .disallowed-task-types {
    font-weight: bold;
    color: red;
  }
  .root .warning {
    font-weight: bold;
    color: red;
  }
  .root.disabled section {
    color: rgba(0, 0, 0, 0.3);
  }
`;

export interface IDynamicCorpJobResponse {
  success?: boolean;
  message: string;
  corpJobOrSfnId?: string;
}

export const formatDynamicCorpJobResponse = (response: IDynamicCorpJobResponse) => {
  const output = `### Latest Response (${response.success ? 'SUCCESS' : 'ERROR'})

  ${response.message}

  ${
    response.success && response.corpJobOrSfnId
      ? `Job Lookup Page <a href="/corp/lookup/${response.corpJobOrSfnId}">here</a>`
      : ''
  }`;

  return output;
};

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const BatchActions: React.FC<{ user: IUserJson }> = ({ user }) => {
  return (
    <div className="root">
      <SectionTitle title="🦩 RoadRunner Utils" />
      <Section name={`Create Delivery Batch`} forceHidden={true}>
        <GenerateDeliveryAction user={user} />
      </Section>
      <Section name={`Update Delivery CSV`} forceHidden={true}>
        <UpdateDeliveryAction user={user} />
      </Section>
      <Section name={`Delivery Info Lookup`} forceHidden={true}>
        <DetailedInfoAction />
      </Section>
      <Section name={`Refresh Audit Information`} forceHidden={true}>
        <RefreshAuditAction />
      </Section>
      <style jsx>{style}</style>
    </div>
  );
};

export default BatchActions;
